import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { GetAllCustomerParents_getAllCustomerParents as CustomerParent } from '../../../types/schemaTypes';
import { CustomButton } from '../../_common';
import SearchableDropdown from '../../_common/SearchableDropdown/SearchableDropdown';
import { Textfield } from '../../_common/Textfield/Textfield';
import { ModalForm } from '../interface';
import './AddEditCustomerParentModal.scss';

interface Option {
    id: number | string;
    name: string | number;
}

interface AddEditCustomerParentModalProps {
    modalForm: ModalForm;
    options: Option[];
    selectedCustomerParent?: CustomerParent;
    onClickHide: () => void;
    onClickSave: (id: number, customerName: string, enabled: boolean, extSystemIdentifier: string) => void;
    show: boolean;
    errorMessage?: string;
}

const AddEditCustomerParentModal = ({
    show,
    options,
    onClickHide,
    onClickSave,
    modalForm,
    selectedCustomerParent,
    errorMessage,
}: AddEditCustomerParentModalProps): React.ReactElement => {
    const [selectedId, setSelectedId] = useState(0);
    const [selectedCustomerParentName, setSelectedCustomerParentName] = useState('');
    const [selectedExtSysIdentifier, setSelectedExtSysIdentifier] = useState('');
    const [selectedEnabled, setSelectedEnabled] = useState(false);
    const [formErrors, setFormErrrors]: any = React.useState({});
    const isEditForm = modalForm === ModalForm.EDIT_CUSTOMER_PARENT;

    useEffect(() => {
        if (selectedCustomerParent) {
            setSelectedId(selectedCustomerParent.id ? selectedCustomerParent.id : 0);
            setSelectedCustomerParentName(
                selectedCustomerParent.customerName ? selectedCustomerParent.customerName : ' ',
            );
            setSelectedExtSysIdentifier(
                selectedCustomerParent.extSystemIdentifier ? selectedCustomerParent.extSystemIdentifier : ' ',
            );
            setSelectedEnabled(selectedCustomerParent.enabled ? selectedCustomerParent.enabled : false);
        }
        setFormErrrors({});
    }, [selectedCustomerParent]);

    const clearState = (): void => {
        setSelectedId(0);
        setSelectedCustomerParentName('');
        setSelectedExtSysIdentifier('');
        setSelectedEnabled(true);
        setFormErrrors({});
    };
    const validateForm = () => {
        const errors = {};

        if (
            !selectedCustomerParentName ||
            (selectedCustomerParent !== undefined && !selectedCustomerParent.customerName)
        ) {
            errors['customerName'] = 'Customer Parent Name is required';
        }
        return {
            isValid: Object.keys(errors).length === 0,
            errors,
        };
    };
    const onSave = (): void => {
        onClickSave(selectedId, selectedCustomerParentName, selectedEnabled, selectedExtSysIdentifier);
        clearState();
    };
    const handleSaveChanges = () => {
        setFormErrrors({});
        const { isValid, errors } = validateForm();

        if (!isValid) {
            setFormErrrors(errors);
            return;
        }
        onSave();
    };
    const onCancel = (): void => {
        clearState();
        onClickHide();
    };

    const changeName = (event: any): void => {
        setSelectedCustomerParentName(event.target.value);
    };
    const changeJDE = (event: any): void => {
        setSelectedExtSysIdentifier(event.target.value);
    };
    const changeStatus = (event: any): void => {
        const boolValue = JSON.parse(event.target.value);

        setSelectedEnabled(boolValue);
    };

    return (
        <Modal show={show} onHide={onClickHide} size="lg">
            <Modal.Header className="AddEditCustomerParentModal-Header">
                <Modal.Title className="AddEditCustomerParentModal-Header-Container">
                    <button className="material-icons AddEditCustomerParentModal-X-Button" onClick={onClickHide}>
                        close
                    </button>
                    <div className="AddEditCustomerParentModal-Title">
                        {isEditForm ? 'Edit CustomerParent' : 'Create New Customer Parent'}
                    </div>
                    <div className="AddEditCustomerParentModal-ErrorMessage">{errorMessage}</div>
                </Modal.Title>
            </Modal.Header>
            <div className="AddEditCustomerParentModal-Upper-TextField-Container">
                <div className="AddEditCustomerParentModal-CmpName">
                    <Textfield
                        label="Customer Parent Name"
                        value={selectedCustomerParent !== undefined ? selectedCustomerParent.customerName : ''}
                        onChange={(event): void => changeName(event)}
                        onBlur={() => {}}
                        error={formErrors.customerName}
                        helperText={formErrors.customerName}
                    />
                </div>
                <div className="AddEditCustomerParentModal-CmpName">
                    <Textfield
                        label="JDE ID#"
                        value={selectedCustomerParent !== undefined ? selectedCustomerParent.extSystemIdentifier : ''}
                        onChange={(event): void => changeJDE(event)}
                        onBlur={() => {}}
                    />
                </div>
            </div>
            <div className="AddEditUserModal-HasAccess-Container">
                <div className="AddEditUserModal-HasAccess-Title">Is Customer Parent Active?</div>
                <div className="AddEditUserModal-HasAccess-Radio-Container">
                    <div className="AddEditUserModal-Radio">
                        <input
                            className="AddEditUserModal-Radio-Input"
                            type="radio"
                            value="true"
                            checked={selectedEnabled}
                            onChange={(event): void => changeStatus(event)}
                        />
                        Yes
                    </div>
                    <div>
                        <input
                            className="AddEditUserModal-Radio-Input"
                            type="radio"
                            value="false"
                            checked={!selectedEnabled}
                            onChange={(event): void => changeStatus(event)}
                        />
                        No
                    </div>
                </div>
            </div>
            <Modal.Footer className="AddEditCustomerParentModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onCancel}></CustomButton>
                <CustomButton title="Save" onClick={handleSaveChanges}></CustomButton>
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditCustomerParentModal;

